/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import { getStaticFileContent, PosthogConfig } from './util/api/staticFiles';
import { posthog } from 'posthog-js';
import { createVueApp } from './setup';
import VueEventer from 'vue-eventer';

if (import.meta.env.VITE_VERSION !== 'onpremises') {
  void (async () => {
    const posthogConfig = await getStaticFileContent<PosthogConfig>('posthog.json');

    if (
      window.location.host.includes(posthogConfig.urlMatch) &&
      posthogConfig.tracking
    ){
      posthog.init('phc_7V1zEchG8t9ibOrQDVyws31G3iRz0SnhPBXj1BKF0xz', {
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'always',
        capture_pageview: false,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
          maskTextFn: (text, element) => {
            if (element?.dataset.record === 'true') {
              return text;
            }
            return '*'.repeat(text.trim().length);
          }
        }
      });
    }
  })();
}

export const app = createVueApp();

export const eventBus = new VueEventer();
